export default __webpack_public_path__ + "static/media/Garbs of the Earth Mother.43e4154a.jpg";